<template>
  <f7-page name="meteo-sucho" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Meteorologické sucho</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar bottom>
      <f7-link tab-link="#tab-hv-okres" tab-link-active>Monitoring</f7-link>
      <f7-link tab-link="#tab-hv-map" >Mapa</f7-link>
    </f7-toolbar>

    <f7-tabs class="wh-100">
      <f7-tab id="tab-hv-okres" @tab:show="onTableTabShow($event)" tab-active>
        <f7-block strong class="no-padding no-margin no-border-top">
          <template v-if="isDatesLoaded">
            <f7-list class="ss-list">
              <f7-list-item title="Dátum:"
                            class="ms-dates-ss-list"
                            smart-select
                            ref="ms-ss-1"
                            :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true,
                            closeOnSelect: true, pageTitle:'Vyberte dátum', popupCloseLinkText:'Návrat',
                            searchbar: {  removeDiacritics:true, customSearch: true, on: { search: searchFromBeginning }, },
                            searchbarPlaceholder: 'Hľadať...'}">
                <select name="station" v-model="selectedDate" @change="onSelectDate($event, 1)">
                  <option v-for="(value, key) in availableDates" :key="key" :value="value">{{ value | moment("DD.MM.YYYY") }}</option>
                </select>
              </f7-list-item>
            </f7-list>
            <f7-block v-if="selectedDate !== null" class="no-margin no-padding">

              <template v-if="isDataLoaded">
                <f7-card v-if="latestData.article.header">
                  <f7-card-header class="c-header-wrap">
                    <div class="c-header">{{ latestData.article.header }}</div>
                    <div class="c-header-sub">{{ latestData.article.dt | moment('DD.MM.YYYY') }} - {{ latestData.article.author }}</div>
                  </f7-card-header>
                  <f7-card-content :padding="false" class="c-content" >
                    <div v-html="latestData.article.content"></div>
                    <br><br>
                  </f7-card-content>
                </f7-card>
                <f7-card v-else>
                  <f7-card-content >
                    Ospravedlňujeme sa, ale k tomuto dátumu je je dostupné slovné hodnotenie
                  </f7-card-content>
                </f7-card>

              </template>
              <template v-else>
                <f7-block strong class="text-align-center no-margin-top">
                  Načítavam údaje...
                </f7-block>
              </template>

            </f7-block>

          </template>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-hv-map" class="wh-100" @tab:show="onMapTabShow($event)">

        <l-map :zoom="zoom"
               :center="center"
               :options="mapOptions"
               ref="mapMS"
               class="ms-map"
        >
          <l-control-zoom position="bottomright"  ></l-control-zoom>
          <l-tile-layer
              ref="layerBg"
              :url="url"
              :attribution="attribution"
          />
          <l-tile-layer :url="borderUrl" />
          <l-geo-json
              ref="geoJsonLayer"
              :geojson="msGeoJsonData"
              :options="geoJsonOptions"
          />

          <l-control :position="'bottomleft'">
            <f7-button class="ms-index-filter-btn text-color-white"
                       fill popover-open=".ms-sucho-popover" icon-f7="slider_horizontal_3"> {{ selectedIndex.toUpperCase() }}</f7-button>
          </l-control>

          <l-control :position="'topleft'">

            <template v-if="isDatesLoaded">
              <f7-list class="ss-list">
                <f7-list-item title="Dátum:"
                              class="ms-dates-ss-list"
                              smart-select
                              ref="ms-ss-2"
                              :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true, closeOnSelect: true, pageTitle:'Vyberte dátum', popupCloseLinkText:'Návrat', searchbar: {  removeDiacritics:true, customSearch: true, on: { search: searchFromBeginning }, }, searchbarPlaceholder: 'Hľadať...'}">
                  <select name="station" v-model="selectedDate" @change="onSelectDate($event, 2)">
                    <option v-for="(value, key) in availableDates" :key="key" :value="value">{{ value | moment("DD.MM.YYYY") }}</option>
                  </select>
                </f7-list-item>
              </f7-list>
            </template>


          </l-control>

          <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
            </div>
          </l-control>

          <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
            </div>
          </l-control>





        </l-map>
      </f7-tab>

    </f7-tabs>

    <f7-popover class="ms-sucho-popover">
      <f7-list>
        <f7-list-item radio :checked="selectedIndex === 'spei'"
                      value="spei"
                      popover-close
                      name="ms_index"
                      title="SPEI"
                      class="ms-index-checkbox"
                      @change="updateIndexFilter"
        >
        </f7-list-item>
        <f7-list-item radio :checked="selectedIndex === 'cmi'"
                      value="cmi"
                      popover-close
                      name="ms_index"
                      title="CMI"
                      class="ms-index-checkbox"
                      @change="updateIndexFilter"
        >

        </f7-list-item>
        <f7-list-item radio :checked="selectedIndex === 'spi'"
                      value="spi"
                      popover-close
                      name="ms_index"
                      title="SPI"
                      class="ms-index-checkbox"
                      @change="updateIndexFilter"
        >
        </f7-list-item>


      </f7-list>
    </f7-popover>


  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LControl, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControlZoom } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import searchMixin from "../js/mixin";
import MeteoSuchoDetail from "./meteo-sucho-detail";
import Dom7 from "dom7";
import store from "../js/store";
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl,
    'meteo-sucho-detail': MeteoSuchoDetail,
  },
  mixins: [
    searchMixin,
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      latestData: [],
      isDataLoaded: false,
      availableDates: [],
      isDatesLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      selectedData: null,
      selectedDate: null,
      isWarnings: false,
      selectedIndex: 'spei',
      selectedFeature: {},
      popupOpened: false,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      isGeoJsonLoaded: false,
      msGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  computed: {
    geoJsonOptions() {
      const data = this.msGeoJsonData;
      const sv = this.selectedIndex;

      return {
        onEachFeature: this.onEachFeatureFunction,
        pointToLayer: this.makePointToLayer,

      };
    },

  },
  watch: {
    isDatesLoaded: function () {
      if (this.selectedDate === null) {
        this.$nextTick(() => {
          this.$f7.smartSelect.get('.ms-dates-ss-list .smart-select').open();
        });
      }
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        self.loadAvailableDates();
      }

    },
    loadAvailableDates: function() {
      const self = this;

      let cached_dates = self.$ls.get('meteo_sucho_dates');
      if (cached_dates !== null) {
        self.availableDates = cached_dates;
        self.selectedDate = self.availableDates[0];
        self.isDatesLoaded = true;
        self.loadData();
      } else {

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'meteodrought/getavailabledates', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                let d = response.data.data;
                self.availableDates = d.sort((a, b) => (a > b) ? -1 : 1);
                self.selectedDate = self.availableDates[0]
                self.isDatesLoaded = true;
                self.loadData();
                self.$ls.set('meteo_sucho_dates', self.availableDates, 1 * 24 * 60 * 60 * 1000); //  1 den
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať informácie o meteorologickom suchu', 'Nastala chyba');
              }
              self.$f7.dialog.close();

            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }

    },
    loadData: function() {
      const self = this;


      self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'meteodrought/getdata?dt=' +  self.selectedDate, {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.latestData = response.data;
              self.isDataLoaded = true;
              self.lastUpdated = self.$moment().unix();

            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje o meteorologickom suchu pre vybraný dátum', 'Nastala chyba');
            }
            self.$f7.dialog.close();
          }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },
    loadGeoJson: function() {
      const self = this;

      self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'meteodrought/getgeojson?dt=' +  self.selectedDate, {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.msGeoJsonData = response.data;
              self.isGeoJsonLoaded = true;
              self.lastUpdated = self.$moment().unix();

            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje o pre mapový podklad', 'Nastala chyba');
            }
            self.$f7.dialog.close();
          }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },
    initMap() {
      const self = this;
      //this.$refs.mapZrazky.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet ZRAZKY init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapMS.mapObject);

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 2*60) { // ak posledne stiahnutie bolo pred vic ako 2 min, tak refresh
        this.pageReload(null, false);
      }
    },
    onMapTabShow(e) {
      // console.log('onMapTabShow');
      this.loadGeoJson();
      this.$refs.mapMS.mapObject.invalidateSize();
    },
    onTableTabShow(e) {
      // console.log('onTableTabShow');
      this.pageReload(null, false);
    },
    onSelectDate(event, from) {
      this.selectedDate = event.target.value;

      // musim updatnut hodnotu datumu v item-after cez DOM lebo v smart-select nefunguje v-model aby to podchytil sam :(
      var $$ = Dom7;
      for (let i = 1; i <=2; i++) {
        let ia = $$(this.$refs['ms-ss-' + i].$el).find('.item-after');
        if (ia) {
          ia.html(this.$moment(this.selectedDate).format('DD.MM.YYYY'));
        }
      }

      this.loadData();
      this.loadGeoJson();
    },

    makePointToLayer: function(feature, latlng)  {
      const self = this;

      let ms_index = 'index_' + self.selectedIndex;

      if (!feature.properties[ms_index]) return;

      let val = feature.properties[ms_index];

      let radius = 8;
      let width = 1;

      let point = L.circleMarker(latlng, {
        radius: radius,
        fillColor: this.getMarkerFillColor(self.selectedIndex, val),
        color: "#000",
        weight: width,
        opacity: 1,
        fillOpacity: 0.9
      });


      point.bindTooltip(feature.properties.name, { direction:'top', offset: [0, 0] });

      return point;

    },
    onEachFeatureFunction: function(feature, layer)  {
      const self = this;

      layer.on({
        click: function (v) {
          if (v.target.feature.id) {
            // console.log('feature clicked:' , v.target.feature);
            self.selectedFeature = v.target.feature;
            // self.popupOpened = true;
            // self.$f7router.navigate('/meteo-sucho/' + v.target.feature.id);
            store.commit('setSelectedMeteoSuchoFeature', v.target.feature);
            self.$f7router.navigate('/meteo-sucho/detail');
          }
        }
      });

    },

    updateIndexFilter(event) {
      const self = this;
      this.selectedIndex = event.target.value;
      self.$f7.popover.close();

    },

    getMarkerFillColor: function(index_type, value) {
      let fillColor = 'rgba(186,186,186,1)';

      if (index_type.toLowerCase() === 'cmi') {
        /*
        mierne sucho od -1,0 do -1,9,
        veľmi sucho od -2,0 do -2,9
        extrémne sucho  od -3,0 nižšie.

        */

        if (value <= -3) fillColor = 'rgba(204,59,0,1)';
        else if (value <= -2) fillColor = 'rgba(253,127,73,1)';
        else if (value <= -1) fillColor = 'rgba(252,238,132,1)';
        else if (value < 1) fillColor = 'rgba(38,138,38,1)';
        else if (value < 2) fillColor = 'rgba(152,244,255,1)';
        else if (value < 3) fillColor = 'rgba(100,183,255,1)';
        else if (value >= 3) fillColor = 'rgba(67,105,222,1)';

      } else
      {
        if (value <= -2) fillColor = 'rgba(204,59,0,1)';
        else if (value <= -1.5) fillColor = 'rgba(253,127,73,1)';
        else if (value <= -1) fillColor = 'rgba(252,238,132,1)';
        else if (value < 1) fillColor = 'rgba(38,138,38,1)';
        else if (value < 1.5) fillColor = 'rgba(152,244,255,1)';
        else if (value < 2) fillColor = 'rgba(100,183,255,1)';
        else if (value >= 2) fillColor = 'rgba(67,105,222,1)';
      }

      return fillColor;

    },

    onPageBeforeOut() {
      const self = this;
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.popover.close();
      self.$f7.popup.close();
    },
    onPageBeforeRemove() {
      const self = this;
      //   console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.popupOpened) self.popupOpened = false;
      if (self.popover) self.popover.destroy();
    },

    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapMS.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapMS.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapMS.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }

  }

};
</script>

<style lang="scss">

.ms-top-bar {
  z-index: 1100;
  position: absolute;
  top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
  left: 0;
  width:100%;
  text-align:center;
  font-size: 12px;
  background-color: rgb(41, 214, 91);
  color: white;
  padding: 5px 0;

}


.ms-map {
  width: 100%;
  height: 100%;
}


.c-header-wrap {
  display: block;
  padding: 10px;
}

.c-header {
  font-size: 14px;
  font-weight: 500;
}
.c-header-sub {
  font-size: 13px;
  color: #8e8e93;
}

.c-content {
  padding: 5px 10px;
}


</style>
